const attachmentFilesEquipmentModelsModal = {
  createTitle: 'incluir archivo adjunto',
  editTitle: 'editar archivo adjunto',
  noResults: 'Ningún resultado encontrado'
};

export default attachmentFilesEquipmentModelsModal;